// ========================================
// SERVICE - Home Page
// Gestion du contenu de la page d'accueil
// ========================================

import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from './config';

const COLLECTION = 'homePage';
const DOC_ID = 'content';

// Structure par défaut de la page d'accueil
const defaultHomeContent = {
  hero: {
    profileImage: null,
    title: 'Gustave KONATE',
    subtitle: 'Communicant • Écrivain • Leader Associatif',
    slogan: 'Communiquer pour transformer, écrire pour inspirer, former pour bâtir l\'avenir.',
    ctaText: 'Découvrir mes projets',
    ctaLink: '/projets'
  },
  introduction: {
    content: '<p>Bienvenue sur mon portfolio ! Je suis Gustave KONATE, un passionné de communication et d\'engagement communautaire basé au Burkina Faso.</p>'
  },
  sypnase: {
    logo: null,
    title: 'Sypnase',
    slogan: 'Human + Tech Link',
    description: 'Agence de communication innovante, alliant expertise humaine et solutions technologiques pour transformer vos idées en réalité.',
    link: ''
  },
  services: [
    {
      id: '1',
      icon: 'file-text',
      title: 'Conception de CV',
      description: 'Création de CV professionnels et percutants pour booster votre carrière.',
      order: 1
    },
    {
      id: '2',
      icon: 'users',
      title: 'Accompagnement professionnel',
      description: 'Coaching et conseils pour votre développement professionnel.',
      order: 2
    },
    {
      id: '3',
      icon: 'pen-tool',
      title: 'Écriture & Storytelling',
      description: 'Rédaction de contenus captivants et narratifs engageants.',
      order: 3
    },
    {
      id: '4',
      icon: 'share-2',
      title: 'Partage d\'opportunités',
      description: 'Veille et diffusion d\'opportunités pour les jeunes.',
      order: 4
    }
  ],
  featuredProjects: [],
  showRecentArticles: 3
};

/**
 * Récupérer le contenu de la page d'accueil
 */
export const getHomeContent = async () => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return { success: true, data: { ...defaultHomeContent, ...docSnap.data() } };
    } else {
      await setDoc(docRef, defaultHomeContent);
      return { success: true, data: defaultHomeContent };
    }
  } catch (error) {
    console.error('Erreur getHomeContent:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour la section Hero
 */
export const updateHero = async (heroData) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      hero: heroData,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateHero:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour l'introduction
 */
export const updateIntroduction = async (introData) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      introduction: introData,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateIntroduction:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour la section Sypnase
 */
export const updateSypnase = async (sypnaseData) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      sypnase: sypnaseData,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateSypnase:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour les services
 */
export const updateServices = async (services) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      services: services,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateServices:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour les projets en vedette
 */
export const updateFeaturedProjects = async (projectIds) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      featuredProjects: projectIds,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateFeaturedProjects:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour tout le contenu de la page d'accueil
 */
export const updateHomeContent = async (content) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      ...content,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateHomeContent:', error);
    return { success: false, error: error.message };
  }
};

export default {
  getHomeContent,
  updateHero,
  updateIntroduction,
  updateSypnase,
  updateServices,
  updateFeaturedProjects,
  updateHomeContent
};